export const RRS_MY_DEBT = {
  type: 'article',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  headline: 'Sjekk din gjeld i Gjeldsregisteret',
  url: 'https://scoopr.no/mingjeld',
  description:
    'Gjeldsregisteret har oversikt over hvor mye alle nordmenn har i kredittgjeld i form av lån eller kredittkort.',
  datePublished: '2021-10-22T08:00:00+00:00',
  dateModified: '2022-01-26T08:00:00+00:00',
};
